import { ErrorBoundary } from "@sentry/react";
import ReactDOM from "react-dom/client";
import { sentrySetup } from "./sentry";
import { AppShell } from "./strict/app/AppShell";
import { MinimalCrashPage } from "./strict/app/MinimalCrashPage";
import { OauthPopupApp } from "./strict/app/OauthPopupApp";
import "./userWorker";

sentrySetup();

// The OAuth credential popup return routes are public and load in a fresh popup window with no Auth0 session.
const hashPath = window.location.hash.replace(/^#/, "").split("?")[0];
const isOauthPopup = hashPath === "/oauthsuccess" || hashPath === "/oauthinvalid";

ReactDOM.createRoot(document.getElementById("react-root") as HTMLElement).render(
  <ErrorBoundary fallback={<MinimalCrashPage />}>{isOauthPopup ? <OauthPopupApp /> : <AppShell />}</ErrorBoundary>
);
